module.exports = __webpack_public_path__ + "static/media/ic_folder_open.6b955864.svg";